import * as loadImage from 'blueimp-load-image';

export class LoadImage {
    public async loadJpeg(file: File, orientation: number): Promise<HTMLCanvasElement> {
        return new Promise<HTMLCanvasElement>((resolve, reject) => {
            loadImage(file, canvas => {
                resolve(canvas);
            }, {
                canvas: true,
                orientation
            });
        });
    }

    public async parseJpegMetadata(file: File): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            loadImage.parseMetaData(file, data => resolve(data));
        });
    }

    public async canvasToBlob(canvas: HTMLCanvasElement): Promise<Blob> {
        return new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(blob => {
                resolve(blob);
            }, 'image/jpeg', 1);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/loadImage.ts